import 'babel-polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import dotenv from 'dotenv';



function getUrlParameters() {
    var urlParams = {};
    (function () {
        var e,
            a = /\+/g,
            r = /([^&=]+)=?([^&]*)/g,
            d = function (s) {
                return decodeURIComponent(s.replace(a, " "));
            },
            q = window.location.search.substring(1);

        while (e = r.exec(q))
            urlParams[d(e[1])] = d(e[2]);
    })();
    return urlParams
};

async function createPonyFill(webchat) {
    const adapters = webchat.createCognitiveServicesSpeechServicesPonyfillFactory(
        {
            credentials: {
                subscriptionKey: process.env.REACT_APP_SPEECH_SERVICE_SUBSCRIPTION_KEY,
                region: 'westeurope'
            }
        }
    );
    return adapters;
}

function redirectToProperUrl() {
    const currentOrigin = window.location.origin;

    const searchPattern = window.location.search;



    // const urlToRedirect = 'https://dev.chatbots.abb.com';

    // const urlToRedirect = 'https://chatbots.abb.com';

    //const urlToRedirect = 'http://localhost:3000';
    const firstUrlToRedirect = 'https://chatbotplatform-webchat.azurewebsites.net';
    const secondUrlToRedirect = 'https://webchatcontrol-newlook.azurewebsites.net';

    const redirectTo = `https://chatbots.abb.com/${searchPattern}`;

    // const redirectTo = `https://dev.chatbots.abb.com/${searchPattern}`;

    // console.log("curent", currentOrigin, urlToRedirect)

    if (currentOrigin === firstUrlToRedirect || currentOrigin === secondUrlToRedirect) {
        window.location.assign(redirectTo);
    }
}

async function init(guid, showHeader, showUpload, devMode, showNewMessagesButton, enableVoiceOver, params) {
    dotenv.config();
    var baseUrl = process.env.REACT_APP_BASE_URL;
    var url = baseUrl + guid;
    var adapter = enableVoiceOver ? await createPonyFill(window.WebChat) : null;
    var response = await fetch(url, { method: 'GET' })
        .then(res => res.text());
    var result = JSON.parse(response);
    var userId = result.userId;
    var chatName = result.chatName;

    ReactDOM.render(<App userID={userId} ponyFillAdapter={adapter} token={result.chatToken.token}
        showUpload={showUpload} devMode={devMode}
        showNewMessagesButton={showNewMessagesButton}
        eventParams={params} />, document.getElementById('root'));

    if (showHeader) {
        ReactDOM.render(<span className="bot-bar">{chatName}</span>, document.getElementById("bar"));
        document.getElementById("root").className = "with-bar";
    }
    document.querySelector('#root > *').focus();
}
redirectToProperUrl();
let urlParams = getUrlParameters();
const { id, showHeader, showUpload, devMode, showNewMessagesButton, enableVoiceOver, ...params } = urlParams;

let guid = id ? id : '';
let headerVisible = showHeader === "true";
let uploadVisible = showUpload === "true";
let devModeParam = devMode === "true";
let showNewMessages = showNewMessagesButton === "true";
let voiceOverEnabled = enableVoiceOver === "true";

if (guid === null || guid === '') {
    ReactDOM.render(<span>BotID is invalid.</span>, document.getElementById('root'));
}
else {
    init(guid, headerVisible, uploadVisible, devModeParam, showNewMessages, voiceOverEnabled, params);
}

// ReactDOM.render(<App guid = { guid } />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
